import { faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { LoadingButton } from '../LoadingButton/LoadingButton'

interface IPortalProps {
  children: React.ReactNode
}

const Portal = ({ children }: IPortalProps) => {
  return createPortal(children, document.body)
}

interface IProps {
  title?: string
  show: boolean
  confirmText?: string
  cancelText?: string
  secondaryButton?: React.ReactElement
  onClose: () => Promise<void> | void
  onSubmit: () => Promise<void> | void
}

export const ConfirmModal = ({
  title = 'Confirm action',
  show,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  secondaryButton,
  onClose,
  onSubmit: handleSubmit,
  children,
}: React.PropsWithChildren<IProps>) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  return (
    <>
      {show && (
        <Portal>
          <div className="modal fade show overlay d-flex justify-content-center">
            <div
              className="slide-in-blurred-top col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-0 my-auto"
              style={{ maxWidth: 'unset' }}
            >
              <form
                onSubmit={async (evt: React.FormEvent) => {
                  evt.preventDefault()
                  setIsSubmitting(true)
                  try {
                    await handleSubmit?.()
                  } catch {}
                  setIsSubmitting(false)
                }}
              >
                <div className="modal-content">
                  <div className="modal-header border-0">
                    <h4 className="modal-title">{title}</h4>
                    <button type="button" className="btn text-body" onClick={onClose}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                  <div className="modal-body">{children}</div>
                  <div className="modal-footer d-flex justify-content-between flex-column-reverse flex-md-row border-0">
                    <button
                      type="button"
                      className="btn btn-link btn-block d-md-inline-block w-md-auto mt-2"
                      onClick={() => onClose()}
                    >
                      {cancelText}
                    </button>
                    {secondaryButton}
                    <LoadingButton
                      type="submit"
                      className="btn btn-primary btn-block d-md-inline-block w-md-auto"
                      loading={isSubmitting}
                    >
                      {confirmText}
                    </LoadingButton>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </Portal>
      )}
    </>
  )
}
